/* eslint-disable
    func-names,
    max-len,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// This is a singleton service for storing information about the users selected date filter.
// It is a singleton Store and has all the expected properties of Store,
// but it's best to access it by injecting `DateFilter` as opposed to
// fetching it like a normal named Store.

const deps = ['Model', '$q', '$filter'];

const factory = function (Model, $q, $filter) {
  class DateFilter extends Model {
    static initClass() {
      this.prototype.start = {
        year: 2014,
        month: 1,
      };

      this.prototype.end = {
        year: 2014,
        month: 12,
      };
    }

    startComposite() {
      return `${this.start.year}-${this.start.month < 10 ? '0' : ''}${this.start.month}`;
    }

    endComposite() {
      return `${this.end.year}-${this.end.month < 10 ? '0' : ''}${this.end.month}`;
    }

    set(startMonth, startYear, endMonth, endYear) {
      this.start.month = startMonth;
      this.start.year = startYear;
      this.end.month = endMonth;
      return (this.end.year = endYear);
    }

    // TODO : combine this with the get current type somehow.
    getCurrentTitle() {
      if (this.start.year === this.end.year) {
        if (this.start.month === 1 && this.end.month === 3) {
          return `Q1 ${this.end.year}`;
        } else if (
          this.start.month === 4 &&
          this.end.month === 6 &&
          this.start.year === this.end.year
        ) {
          return `Q2 ${this.end.year}`;
        } else if (
          this.start.month === 7 &&
          this.end.month === 9 &&
          this.start.year === this.end.year
        ) {
          return `Q3 ${this.end.year}`;
        } else if (
          this.start.month === 10 &&
          this.end.month === 12 &&
          this.start.year === this.end.year
        ) {
          return `Q4 ${this.end.year}`;
        } else if (this.start.month === 1 && this.end.month === 12) {
          const currentYear = new Date().getFullYear();

          if (currentYear === this.end.year) {
            return 'This Year';
          } else if (currentYear - 1 === this.end.year) {
            return 'Last Year';
          }
          return this.end.year.toString();
        } else if (this.start.month === this.end.month) {
          return `${$filter('blMonth')(this.start.month)} ${this.end.year}`;
        }
        return 'Custom Range';
      }
      return 'Custom Range';
    }

    // TODO : revisit this.
    getCurrentType() {
      if (this.start.year === this.end.year) {
        if (this.start.month === 1 && this.end.month === 3) {
          return 'Q1';
        } else if (
          this.start.month === 4 &&
          this.end.month === 6 &&
          this.start.year === this.end.year
        ) {
          return 'Q2';
        } else if (
          this.start.month === 7 &&
          this.end.month === 9 &&
          this.start.year === this.end.year
        ) {
          return 'Q3';
        } else if (
          this.start.month === 10 &&
          this.end.month === 12 &&
          this.start.year === this.end.year
        ) {
          return 'Q4';
        } else if (this.start.month === 1 && this.end.month === 12) {
          return '0';
        } else if (this.start.month === this.end.month) {
          return this.start.month.toString();
        }
        return 'Custom';
      }
      return 'Custom';
    }
  }
  DateFilter.initClass();

  return new DateFilter();
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name, require('data/date').name];

module.exports = angular.module('bench.data.dateFilter', moduleDeps).factory('DateFilter', factory);
